module.exports = __webpack_public_path__ + "img/director.aca00fba.jpeg";